import * as ngCdkDragDrop from '@angular/cdk/drag-drop'
import * as ngCore from '@angular/core'

import * as input from '../../../input'
import type * as models from '../../models'
import { Store } from '../../store'

/** Renders and measures the prepared column headers. */
@ngCore.Component({
  imports: [input.checkbox.Component, ngCdkDragDrop.DragDropModule],
  selector: 'atn-ds-table-column-headers',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Shared table state used by the template. */
  public readonly store = ngCore.inject(Store)

  /** Header label elements measured for double-click column fitting. */
  private readonly _columnContentElementsSg =
    ngCore.viewChildren<ngCore.ElementRef<HTMLElement>>('columnContent')

  /** Records header label widths after their latest render. */
  constructor() {
    ngCore.afterRenderEffect(() => {
      // Track layout so label updates retrigger unchanged DOM queries.
      this.store.layoutSg()
      // Header labels are measured after Angular has committed their current
      // text. The maximum is retained by the store and participates in the
      // next layout calculation used by both header and body.
      for (const content of this._columnContentElementsSg()) {
        const columnId = content.nativeElement.dataset.columnId
        if (columnId) {
          this.store.updateColumnContentWidth(
            columnId,
            content.nativeElement.scrollWidth,
          )
        }
      }
    })
  }

  /** Forwards the completed drag distance to the table sizing state. */
  public columnResizeDroppedHandler(
    event: ngCdkDragDrop.CdkDragDrop<unknown>,
    columnId: models.Column.Id,
  ): void {
    this.store.resizeColumn(columnId, event.distance.x)
  }

  /** Fits a column to the widest content measured by header and rows. */
  public columnDblClickHandler(columnId: models.Column.Id): void {
    this.store.fitColumn(columnId)
  }

  /** Requests the next direction from a controlled sortable column. */
  public columnSortClickHandler(sort: models.Column.Sort): void {
    this.store.changeSort(sort)
  }
}
